module.exports = __webpack_public_path__ + "static/media/background_sample.0510cef5.png";